import { Space } from 'antd';
import { get } from 'lodash-es';
import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Outlet } from 'react-router-dom';

import { LeftLayout } from '@component/layout/common/common-layout';
import { useCurrentApplication } from '@hook/application/use-current-application.hook';
import { useInit } from '@hook/common/use-init.hook';
import { useStoreSelector } from '@hook/store/store.hooks';
import { isExist } from '@util/data/is-exist';

import { MainGuid } from './main-guide/main-guid';
import { MainHamburger } from './main-hamburger/main-hamburger';
import { LayoutContent, LayoutHeader, MainWrapper, ManiContentLayout, RightSideLayout } from './main-layout.style';
import { UserVerified } from './user-verified/user-verified';

export const MainLayout = () => {
  const { Aside, Header } = useInit();
  const routeName = useStoreSelector((state) => state.route.name);
  const application = useCurrentApplication();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const applicationId = get(application, ['current', 'id']);

  useEffect(() => void setIsMobileMenuOpen(false), [routeName, isMobile, applicationId]);

  return (
    <>
      <ManiContentLayout isMobileMenuOpen={isMobileMenuOpen}>
        <MainWrapper>
          <LeftLayout
            isMobile={isMobile}
            isMobileMenuOpen={isMobileMenuOpen}
            onClose={() => setIsMobileMenuOpen(false)}
          >
            {isExist(Aside) && <Aside />}
          </LeftLayout>
          <RightSideLayout>
            <MainHamburger
              isMobile={isMobile}
              isMobileMenuOpen={isMobileMenuOpen}
              onClick={() => setIsMobileMenuOpen(true)}
            />
            <UserVerified />
            {isExist(Header) && (
              <LayoutHeader>
                <Space align='baseline'>
                  <Header />
                </Space>
              </LayoutHeader>
            )}
            <LayoutContent>
              <Outlet />
            </LayoutContent>
          </RightSideLayout>
        </MainWrapper>
      </ManiContentLayout>
      <MainGuid />
    </>
  );
};
